import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgThumbsUpIconSecondary from './svgs/ThumbsUpIconSecondary.js';
import SvgThumbsUpIcon from './svgs/ThumbsUpIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var thumbsUpIcon = (props => useIcon(SvgThumbsUpIcon, SvgThumbsUpIconSecondary, props));

export { thumbsUpIcon as default };
